import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

export const MicrosoftLoginRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const redirectEndpoint = searchParams.get('redirectEndpoint');
    const baseUrl = `${import.meta.env.VITE_MERMAIDD_API_URL}/mermaidd/login`;

    // If there's a redirectEndpoint, append it as a query parameter
    if (redirectEndpoint) {
      window.location.href = `${baseUrl}?redirectEndpoint=${encodeURIComponent(redirectEndpoint)}`;
    } else {
      window.location.href = baseUrl;
    }
  }, [searchParams]);

  return <div>Redirecting to Microsoft Login...</div>;
};
